module.exports = __webpack_public_path__ + "static/media/no-image-box-eddie.09d4c583.jpg";